module.exports = __webpack_public_path__ + "img/failure-icon.abd3ffc0.svg";